import React from "react";
import { Link } from "gatsby";
import TextSection from "./textSection";

export default function SousTitreText({
    index,
    url,
    Titre,
    Text,
    Color,
    textColor,
    Reference,
    inView
}) {

    return (
        <>
            {
                url
                    ? <Link key={index} to={url}>
                        <h3
                            key={index}
                            className={`text-lg font-medium ${Color} ${Reference ? 'animate' : ''} mb-2`}
                        >
                            {Titre}
                        </h3>
                    </Link>
                    : <h3
                        key={index}
                        className={`text-lg font-medium ${Color} ${Reference ? 'animate' : ''} mb-2`}
                    >
                        {Titre}
                    </h3>
            }
            <TextSection
                key={index+'-'+Titre}
                content={Text}
                color={textColor}
                size='s'
                inView={inView}
                reference={Reference}
            />
        </>
    )
}